import { Box, Tabs, Tab } from "@mui/material";

export default function TabsTitles({ handleChange, value, tabs, tabstyle, selectedTabStyle }) {

  return (
    <Box
      sx={{
        ".MuiTab-root": {
          color: "#BDBDBD",
          textTransform: "capitalize",
          fontSize: { xs: "14px", sm: "18px", md: "24px" },
          px: { xs: 2, sm: 3, md: 5 },
          fontWeight: "400",
          minWidth: "auto",
        },
        ".Mui-selected": {
          backgroundColor: "white",
          textDecoration: "capitalize",
          color: "black !important",
          ...selectedTabStyle,
        },
      }}
    >
      <Tabs
        TabIndicatorProps={{
          style: {
            display: "none",
          },
        }}
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{ m: 0 }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {tabs.map((tab, i) => (
          <Tab label={tab?.title} key={i} disableRipple sx={{ ...tabstyle }} />
        ))}
      </Tabs>
    </Box>
  );
}
